function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.24219 1.21875C8.45312 1.35938 8.54688 1.61719 8.47656 1.875L7.09375 6H9.92969C10.375 6 10.75 6.375 10.75 6.82031C10.75 7.05469 10.6562 7.28906 10.4688 7.42969L3.4375 13.7344C3.25 13.8984 2.96875 13.9219 2.75781 13.7812C2.54688 13.6406 2.45312 13.3828 2.52344 13.1484L3.90625 9H1.07031C0.625 9 0.25 8.625 0.25 8.17969C0.25 7.94531 0.34375 7.73438 0.53125 7.57031L7.5625 1.26562C7.75 1.10156 8.03125 1.07812 8.24219 1.21875ZM1.86719 7.875H4.67969C4.86719 7.875 5.03125 7.96875 5.14844 8.10938C5.24219 8.25 5.28906 8.4375 5.21875 8.625L4.25781 11.4844L9.13281 7.125H6.32031C6.13281 7.125 5.96875 7.03125 5.85156 6.89062C5.75781 6.75 5.73438 6.5625 5.78125 6.375L6.74219 3.51562L1.86719 7.875Z",
  fill: "#006CA3"
});

function SvgQuickSetupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSetupIcon);
export default __webpack_public_path__ + "static/media/quick-setup-icon.dca55180.svg";
export { ForwardRef as ReactComponent };